/**
 * @generated SignedSource<<628e494db6ecc4789a2cc39c74b66970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpgradeToFullOrganizationInput = {
  organizationName: string;
};
export type Profile_upgradeToFullOrganization_Mutation$variables = {
  input: UpgradeToFullOrganizationInput;
};
export type Profile_upgradeToFullOrganization_Mutation$data = {
  readonly upgradeToFullOrganization: {
    readonly organization: {
      readonly id: string;
      readonly name: string;
      readonly thin: boolean;
    };
  } | null;
};
export type Profile_upgradeToFullOrganization_Mutation = {
  response: Profile_upgradeToFullOrganization_Mutation$data;
  variables: Profile_upgradeToFullOrganization_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpgradeToFullOrganizationPayload",
    "kind": "LinkedField",
    "name": "upgradeToFullOrganization",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thin",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Profile_upgradeToFullOrganization_Mutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Profile_upgradeToFullOrganization_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5ae6ea2f35d46d8f90dec57dceeaffff",
    "id": null,
    "metadata": {},
    "name": "Profile_upgradeToFullOrganization_Mutation",
    "operationKind": "mutation",
    "text": "mutation Profile_upgradeToFullOrganization_Mutation(\n  $input: UpgradeToFullOrganizationInput!\n) {\n  upgradeToFullOrganization(input: $input) {\n    organization {\n      id\n      name\n      thin\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d976d98f51a06950148b3e17b0adcb6";

export default node;
